import styled from 'styled-components';

export const MpSection = styled(`section`)`
	display: flex;
	justify-content: center;
	align-items: center;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
	}
`;
